
import { extractAllBlocksFromTpl, getRollupPossibilities, generateFilterKey } from "@okf/ootils";


/**
 * Helper to build rollup path description with "via"
 * Takes rollupPath array and resolves each item to its display title
 * Returns "via Title1 → Title2 → Title3" (all items except the last one)
 */
const _buildRollupPathDesc = ({rollupPath, allTpls}) => {
  // Everything except the last item forms the "via" path
  const pathWithoutDestination = rollupPath.slice(0, -1);

  const pathDisplayNames = pathWithoutDestination.map(item => {
    const tpl = allTpls.find(t => t.kp_content_type === item);
    return tpl?.general?.content?.title || item;
  });

  return `via ${pathDisplayNames.join(' → ')}`;
};

export const _getRollupOptions = ({tagBlocksOnThisTpl = [], allTpls, isAnno, thisContentType}) => {
  let allRollupPossibilities = [];
    for (const tagBlock of tagBlocksOnThisTpl) {
      const thisRollupPossibilities = getRollupPossibilities({tagType: tagBlock.props.tagType, allTpls});
      allRollupPossibilities = [
        ...allRollupPossibilities,
        ...thisRollupPossibilities
      ];
    }

    const rollupOptionsToReturn = allRollupPossibilities.map(op => {
      const thisRolledupTagTpl = allTpls.find(tpl => tpl.kp_content_type === op.tagTypeCollectionToRollup);
      const blocksOf_thisRolledupTagTpl = extractAllBlocksFromTpl({tpl: thisRolledupTagTpl});

      if (op.rollupType === 'valuePathType') {
        const blockConfigOfRollupValuePath = blocksOf_thisRolledupTagTpl.find(bl => bl.valuePath === op.blockValuePath);
        return ({
          ...op,
          display: blockConfigOfRollupValuePath?.props.shortLabel || blockConfigOfRollupValuePath?.props.label || blockConfigOfRollupValuePath,
          desc: `via ${thisRolledupTagTpl?.general?.content?.title || op.tagTypeCollectionToRollup}`,
          value: thisContentType + '__VIA__' + op.tagTypeCollectionToRollup + '__' + op.blockValuePath,
          // Matches the key on the equivalent generated filter — both derive
          // from this same `op` out of getRollupPossibilities.
          filterKey: generateFilterKey({
            filterType: 'rollupValuePathType',
            tagTypeCollectionToRollup: op.tagTypeCollectionToRollup,
            valuePathInRolledUpCollection: op.valuePathInRolledUpCollection,
          }),
          ...(isAnno !== undefined ? {isAnno} : {}), //needed in processrawconfig to pass isAnno to the dimensions property of aggrmetricsacrossdimensions
          contentType: thisContentType //needed cuz, when we define a dimension for aggrmetricsacrossdimensions, when the main 'contentType' is 'annotations', then in the dimension we have to specify which contenttype this dimension's valuepath is coming from since annotations is a collection of several different content types.
        });
      } else if (op.rollupType === 'tagType') {
        const finalItem = op.rollupPath[op.rollupPath.length - 1];
        const isHybridChain = op.isTerminalValuePath || finalItem.startsWith('main.');
        const fallbackDisplay = isHybridChain
          ? finalItem
          : (allTpls.find(tpl => tpl.kp_content_type === finalItem)?.general?.content?.title || finalItem);
        // Prefer the tag field's own template label (shortLabel/label, set as
        // filterDisplay by getRollupPossibilities). Without this, non-hybrid tag
        // rollups fall back to the raw tag-collection contentType — which is why
        // fields like country / stateCounty / districtSubCounty showed raw keys.
        const display = op.filterDisplay || fallbackDisplay;

        return ({
          ...op,
          display,
          desc: _buildRollupPathDesc({rollupPath: op.rollupPath, allTpls}),
          value: thisContentType + '__VIA__' + op.rollupPath.join('__'),
          filterKey: generateFilterKey({
            filterType: 'nestedRollupTagType',
            rollupPath: op.rollupPath,
          }),
          ...(isAnno !== undefined ? {isAnno} : {}),
          contentType: thisContentType
        });
      }
    });

    return rollupOptionsToReturn;
}